export default __webpack_public_path__ + "static/media/sho2.09286d14.jpg";